import { CommonEnums } from 'src/app/shared/common.enums';
import { DatabaseWrappersFactory } from 'src/app/shared/databases/database.wrappers.factory';
import { Datatype } from 'src/app/shared/databases/datatype';
import { DatabaseWrapper } from 'src/app/shared/databases/database.wrapper';
import { Attribute } from 'src/app/shared/models/domain/attribute';
import { ObjectWrapper } from 'src/app/shared/wrappers/object.wrapper';
import { ObjectWrapperUtil } from 'src/app/shared/utils/object.wrapper.util';
import { Util } from 'src/app/shared/utils/util';
import { ErrorCdsEnums } from 'src/app/shared/errorcds.enums';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { DataObjectWrapper } from '../../../modules/dataobject/dataobject.wrapper';
import { ObjectUtil } from 'src/app/shared/utils/object.util';
import { ArrayUtil } from 'src/app/shared/models/utils/array.util';
import { SelectTransformWrapper } from 'src/app/modules/design/transforms/selecttransform/selecttransform.wrapper';
import { Transformation } from '../../models/objs/transformation';
import { DesignWrapper } from 'src/app/modules/design/design.wrapper';
import { TransformWrapper } from 'src/app/modules/design/transforms/transform.wrapper';

export class AttributesUtil {
    private static instance: AttributesUtil;

    static getInstance() {
        if (!AttributesUtil.instance) {
            AttributesUtil.instance = new AttributesUtil();
        }
        return AttributesUtil.instance;
    }

    attrKeyTyp_Ids: Array<any> = [
        { "value": "0", "label": "Not a Key" },
        { "value": "1", "label": "Primary Key" },
        { "value": "2", "label": "Foreign Key" }
    ];

    util: Util;
    objectsUtil: ObjectUtil;
    objectWrapperUtil: ObjectWrapperUtil;

    /**
      * AttributesUtil is a singleton class, so use AttributesUtil.getInstance() method instead of creating new AttributesUtil().
      */
    private constructor() {
        this.util = Util.getInstance();
        this.objectsUtil = ObjectUtil.getInstance();
        this.objectWrapperUtil = ObjectWrapperUtil.getInstance();
    }

    insert(attribute: Attribute, attributes: Array<Attribute>, objectWrapper: ObjectWrapper, index: number = -1): void {
        if (index == -1) {
            index = attributes.length;
        }

        attributes.splice(index, 0, attribute);
        this.objectsUtil.resetSrt_Order(attributes, index);

        let parent_Attr_IdString: string = attribute.parent_Attr_Id == -1 ? '' : attribute.parent_Attr_Id.toString();
        this.objectWrapperUtil.addSubName(attribute.attrNm.toUpperCase(), objectWrapper, parent_Attr_IdString);
        this.objectWrapperUtil.addSub_Id(attribute.attr_Id, attribute, objectWrapper)
    }

    insertAt(attribute: Attribute, attributes: Array<Attribute>, index: number, objectWrapper: ObjectWrapper) {
        attributes.splice(index, 0, attribute);

        this.objectWrapperUtil.resetSrt_Order(attributes);

        this.objectWrapperUtil.addSubName(attribute.attrNm.toUpperCase(), objectWrapper, attribute.parent_Attr_Id.toString());
        this.objectWrapperUtil.addSub_Id(attribute.attr_Id, attribute, objectWrapper)
    }

    remove(selectedAttributes: Array<Attribute>, attributes: Array<Attribute>, objectWrapper: ObjectWrapper) {
        let attr_Ids: Array<number> = new Array<number>();
        for (let i: number = 0; i < selectedAttributes.length; i++) {
            attr_Ids.push(selectedAttributes[i].attr_Id);
        }

        for (let i: number = 0; i < attributes.length; i++) {
            let attribute: Attribute = attributes[i];

            if (attr_Ids.indexOf(attribute.attr_Id) != -1) {
                attributes.splice(i, 1);
                this.objectWrapperUtil.removeSubName(attribute.attrNm, objectWrapper);
                this.objectWrapperUtil.removeSub_Id(attribute.attr_Id, objectWrapper);
                i--;
            }
        }

        for (let i: number = 0; i < attributes.length; i++) {
            attributes[i].srt_Order = i;
        }

        objectWrapper.doValidate();
    }

    getNewAttribute(objectWrapper: ObjectWrapper, attrType_Cd: string, parent_Attr_Id: number = -1): Attribute {
        let attribute = new Attribute();

        attribute.attr_Id = this.objectWrapperUtil.getNewSub_Id(objectWrapper);
        let parent_Attr_IdString: string = parent_Attr_Id == -1 ? '' : parent_Attr_Id.toString();

        attribute.attrNm = this.util.getNewName('ATTR_NAME_1', objectWrapper.getSubNames(), parent_Attr_IdString);

        attribute.attrType_Cd = attrType_Cd == undefined ? 'A' : attrType_Cd;

        attribute.obj_Id = objectWrapper.obj_Id;
        attribute.dxMp_Id = objectWrapper.dxMp_Id;

        let datatype = DatabaseWrappersFactory.getInstance().getDefaultDatatype(objectWrapper.nativeDbTyp_Id);  // changed
        if (datatype) {
            attribute.attrDTyp_Id = datatype.id;
            attribute.attrPrec = datatype.defaultprecision;
            attribute.attrScale = datatype.defaultscale;
        }

        if (attrType_Cd == CommonEnums.attrType_Cd.DERIVED_ATTRIBUTE) {
            attribute.attrType_Cd = CommonEnums.attrType_Cd.DERIVED_ATTRIBUTE;
            attribute.valid_Cd = 'EMPT_COND';
            attribute.error_Msg = this.objectWrapperUtil.getError_Msg(attribute.valid_Cd);
        }

        if (objectWrapper && objectWrapper.dbTyp_Id == 43) {
            attribute.colformat = 'DIMENSION';
            attribute.category = 'User';
        }

        this.setAttributeReadOnlyProperties(attribute, objectWrapper);

        return attribute;
    }

    getNewAttributeForRecord(objectWrapper: ObjectWrapper, attrType_Cd: string, parent_Attr_Id: number = -1, attributes: Array<Attribute>): Attribute {
        let attribute = new Attribute();

        attribute.attr_Id = this.objectWrapperUtil.getNewSub_Id(objectWrapper);
        let parent_Attr_IdString: string = parent_Attr_Id == -1 ? '' : parent_Attr_Id.toString();

        attribute.attrNm = this.util.getNewName('RECORD_ID', objectWrapper.getSubNames(), parent_Attr_IdString);
        attribute.attrType_Cd = attrType_Cd == undefined ? 'A' : attrType_Cd;

        attribute.obj_Id = objectWrapper.obj_Id;
        attribute.dxMp_Id = objectWrapper.dxMp_Id;

        let dbTypId = objectWrapper.nativeDbTyp_Id == DatabaseEnum.bigquery.ID ? 4 : -5;

        let datatype = DatabaseWrappersFactory.getInstance().getDefaultDatatypeForRecord(objectWrapper.nativeDbTyp_Id, dbTypId);  // changed
        if (datatype) {
            attribute.attrDTyp_Id = datatype.id;
            attribute.attrPrec = datatype.defaultprecision;
            attribute.attrScale = datatype.defaultscale;
        }

        if (attrType_Cd == CommonEnums.attrType_Cd.DERIVED_ATTRIBUTE) {
            attribute.attrType_Cd = CommonEnums.attrType_Cd.DERIVED_ATTRIBUTE;
            attribute.valid_Cd = '0';
            attribute.error_Msg = this.objectWrapperUtil.getError_Msg(attribute.valid_Cd);
        }

        if (objectWrapper && objectWrapper.dbTyp_Id == 43) {
            attribute.colformat = 'DIMENSION';
            attribute.category = 'User';
        }

        let sortAttributesName = "";
        let selectTransformWrapper: SelectTransformWrapper = objectWrapper as SelectTransformWrapper;
        for (let i: number = 0; i < selectTransformWrapper.selectTransform.attributes.length; i++) {
            let attribute: Attribute = selectTransformWrapper.selectTransform.attributes[i];
            if (attribute.sortBy == 0) continue;
            if (sortAttributesName == '') {
                sortAttributesName = attribute.fldValue;
            } else {
                sortAttributesName += ',' + attribute.fldValue;
            }
        }


        let attr_Nm = sortAttributesName == '' ? attributes[attributes.length - 1].fldValue : sortAttributesName;

        //  attribute.attrExprVal = "ROW_NUMBER() OVER(ORDER BY " + attr_Nm + ")"

        this.setAttributeReadOnlyProperties(attribute, objectWrapper);

        return attribute;
    }

    setAttributeReadOnlyPropertiesToEmpty(attribute: Attribute): void {
        attribute.attrDTypNm = '';
        attribute.showAttrPrec = false;
        attribute.showAttrScale = false;
        attribute.showExplodeFlg = false;
        attribute.maxAttrPrec = 1000;
        attribute.maxAttrScale = 1000;


        attribute.attrKeyTypLabel = '';

        attribute.hideAttrDTyp_Id = false;
        attribute.hideNotNullFlag = false;
        attribute.hideAttrKeyTyp_Id = false;
        attribute.hideDistKeyFlag = false;
        attribute.hideFldFormatValue = false;
        attribute.hideOrderBy = false;
        attribute.hideOccurs = false;
        attribute.hideDependingOn = false;
        attribute.hideSigned = false;
        attribute.hideTsigned = false;
        attribute.hideIsigned = false;
        attribute.hideRdeci = false;
        attribute.error_Msg = '';
    }

    setAttributeReadOnlyProperties(attribute: Attribute, objectWrapper: ObjectWrapper, fromNew: boolean = false): void {
        if (!objectWrapper.databaseWrapper) return;

        this.setAttributeReadOnlyPropertiesToEmpty(attribute);

        let nativeDbTyp_Id = objectWrapper.nativeDbTyp_Id == -2 || objectWrapper.nativeDbTyp_Id == -6 || objectWrapper.object.hasOwnProperty('tgt_Inst') ? objectWrapper.dbTyp_Id : objectWrapper.nativeDbTyp_Id;

        if (objectWrapper.obj_Cd == CommonEnums.codes.MASKING) {
            let transformWrapper: TransformWrapper = objectWrapper as TransformWrapper;
            let sourcewrapper = transformWrapper.designWrapper.getTransformWrapper(attribute.lnk_Obj_Id);
            nativeDbTyp_Id = sourcewrapper.dbTyp_Id;
        }

        let _datatype: Datatype = DatabaseWrappersFactory.getInstance().getDatatype(nativeDbTyp_Id, attribute.attrDTyp_Id);
        if (!_datatype) return;

        attribute.hideFldFormatValue = objectWrapper.databaseWrapper.hideFldFormatValue(attribute);

        attribute.attrDTypNm = _datatype.name;
        attribute.showAttrPrec = _datatype.enableprecision != CommonEnums.flag.no;

        if (attribute.maxFlag == "Y") {
            attribute.showAttrPrec = false;
        }

        if (attribute.transpose == 'Y' && objectWrapper.databaseWrapper.dbTyp_Id != 52) {
            attribute.showAttrPrec = false;// DDS-8151 
        }
        attribute.showAttrScale = _datatype.enablescale != 'n';
        attribute.showExplodeFlg = _datatype.enableexplode != 'n'
            ;
        attribute.maxAttrPrec = _datatype.maxprec;
        attribute.maxAttrScale = _datatype.maxscale;
        attribute.minAttrPrec = _datatype.minprec ? _datatype.minprec : -1;

        if (_datatype.hasOwnProperty('minprec') && _datatype.hasOwnProperty('minscale') && _datatype.minprec != null) {
            attribute.minAttrPrec = _datatype.minprec;
            attribute.minAttrScale = _datatype.minscale;
        }
        if (_datatype && fromNew) {
            attribute.attrPrec = _datatype.defaultprecision;
            attribute.attrScale = _datatype.defaultscale;
        }
        if (objectWrapper.hasOwnProperty('carryForwardAttributesHMapIds')) {
            let attributeObject: any = objectWrapper.carryForwardAttributesHMapIds.get(attribute.lnk_Obj_Id + '-' + attribute.lnk_Attr_Id);
            if (attributeObject) {
                attribute.srcColNm = objectWrapper.obj_Cd == 'DOBJIS' ? attributeObject.text : attributeObject.name;
                // attribute.srcDTypNm = AttributesUtil.getInstance().getAttributeType(nativeDbTyp_Id, attributeObject);
                let dbTyp_Id = objectWrapper.obj_Cd == CommonEnums.codes.MASKING ? nativeDbTyp_Id : objectWrapper.dbTyp_Id;
                attribute.srcDTypNm = AttributesUtil.getInstance().getAttributeType(dbTyp_Id, attributeObject);

            } else {
                if (objectWrapper.obj_Cd != CommonEnums.codes.MASKING) {
                    attribute.srcColNm = ''; //_datatype.maxscale;
                    attribute.srcDTypNm = '';
                }

            }
        }

        if (objectWrapper.hasOwnProperty('output')) {
            let attributeObject: any = objectWrapper.carryForwardAttributesHMapIds.get(attribute.lnk_Obj_Id + '-' + attribute.lnk_Attr_Id);
            if (attributeObject) {
                attribute.srcColNm = attributeObject.name;
                attribute.srcDTypNm = AttributesUtil.getInstance().getAttributeType(objectWrapper.dbTyp_Id, attributeObject);
            }
        }

        attribute.attrKeyTypLabel = '';
        for (let i: number = 0; i < this.attrKeyTyp_Ids.length; i++) {
            if (this.attrKeyTyp_Ids[i].value == attribute.attrKeyTyp_Id) {
                attribute.attrKeyTypLabel = this.attrKeyTyp_Ids[i].label;
                break;
            }
        }

        attribute.error_Msg = ErrorCdsEnums.errorcds[attribute.valid_Cd];
        // attribute.error_Msg = attribute.valid_Cd == "0" ? '' : ErrorCdsEnums.errorcds[attribute.valid_Cd];
        // attribute.sortType = attribute.sortType == undefined ? 'A' : attribute.sortType;

        if (objectWrapper.obj_Cd == 'DOBJ' &&
            objectWrapper.nativeDbTyp_Id == DatabaseEnum.xsd.ID &&
            (objectWrapper as DataObjectWrapper).dataObject.attributes.length > 0) {
            let attributeTmp = (objectWrapper as DataObjectWrapper).dataObject.attributes[0];
            attributeTmp.occurs = -1;
            attributeTmp.hideAttrDTyp_Id = true;
        }
    }

    appendChildAttributes(selectedAttributes: Array<Attribute>, attributes: Array<Attribute>): void {
        let selectedAttr_Ids: Array<number> = new Array<number>();
        for (let i: number = 0; i < selectedAttributes.length; i++) {
            selectedAttr_Ids.push(selectedAttributes[i].attr_Id);
        }

        for (let i: number = 0; i < attributes.length; i++) {
            let attribute: Attribute = attributes[i];

            if (selectedAttr_Ids.indexOf(attribute.parent_Attr_Id) != -1) {
                if (selectedAttr_Ids.indexOf(attribute.attr_Id) == -1) {
                    selectedAttributes.push(attribute);
                }

                if (selectedAttr_Ids.indexOf(attribute.attr_Id) == -1) {
                    selectedAttr_Ids.push(attribute.attr_Id);
                }
            }
        }

        ArrayUtil.getInstance().sortBySrt_Order(selectedAttributes);
    }

    getChildAttributes(parentAttribute: Attribute, attributes: Array<Attribute>): Array<Attribute> {
        // check for complex attribute type

        let attr_Ids: Array<number> = new Array<number>();
        attr_Ids.push(parentAttribute.attr_Id);

        let childAttributes: Array<Attribute> = new Array<Attribute>();
        for (let i: number = parentAttribute.srt_Order + 1; i < attributes.length; i++) {
            let attribute: Attribute = attributes[i];
            if (attr_Ids.indexOf(attribute.parent_Attr_Id) == -1) break;

            childAttributes.push(attribute);

            if (attr_Ids.indexOf(attribute.attr_Id) == -1) {
                attr_Ids.push(attribute.attr_Id);
            }
        }

        return childAttributes;
    }

    getUpJumpCountsMap(selectedAttributes: Array<Attribute>, attributes: Array<Attribute>): Map<number, number> {
        let upJumpCountsMap: Map<number, number> = new Map<number, number>();

        for (let i: number = 0; i < selectedAttributes.length; i++) {
            let selectedAttribute: Attribute = selectedAttributes[i];
            let jumpCount: number = upJumpCountsMap.get(selectedAttribute.parent_Attr_Id);
            if (!jumpCount) {
                jumpCount = 0;

                let attributeAbove: Attribute = attributes[selectedAttribute.srt_Order - 1];
                if (attributeAbove.clevel > selectedAttribute.clevel) {
                    for (let i: number = selectedAttribute.srt_Order - 1; i >= 0; i--) {
                        jumpCount++;

                        if (selectedAttribute.clevel == attributes[i].clevel) {
                            break;
                        }
                    }
                } else {
                    jumpCount = 1;
                }
            }

            upJumpCountsMap.set(selectedAttribute.attr_Id, jumpCount);
        }

        return upJumpCountsMap;
    }

    flagChanged(attribute: Attribute, attributes: Array<Attribute>, fieldName: string, otherFieldNames: Array<string>): void {
        for (let i: number = 0; i < attributes.length; i++) {
            let attributeExist: Attribute = attributes[i];
            if (attribute.attr_Id == attributeExist.attr_Id) continue;

            if (attribute[fieldName] == attributeExist[fieldName]) {
                attributeExist[fieldName] = 0;
                break;
            }
        }

        for (let i = 0; i < attributes.length; i++) {
            let attributeExist = attributes[i];

            if (attribute.attr_Id == attributeExist.attr_Id) {
                for (let j = 0; j < otherFieldNames.length; j++) {
                    attributeExist[otherFieldNames[j]] = 0;
                }
            }

            if (fieldName == "upiFlag") {
                attributeExist['nupiFlag'] = 0;
            } else if (fieldName == "nupiFlag") {
                attributeExist['upiFlag'] = 0;
            }
        }
    }

    getCLevels(attributes: Array<Attribute>): Array<number> {
        let cLevels: Array<number> = new Array<number>();

        let j: number;
        for (let i: number = 0; i < attributes.length; i++) {
            let attribute: Attribute = attributes[i];
            if (cLevels.indexOf(attribute.clevel) != -1) continue;

            for (j = 0; j < cLevels.length; j++) {
                if (cLevels[j] > attribute.clevel)
                    break;
            }

            cLevels.splice(j, 0, attribute.clevel);
        }
        return cLevels;
    }

    getAttributeType(dbTyp_Id: number, attributeObj: any): string {
        let dataTypeName: string = '';
        let datatype: Datatype;

        if (attributeObj) {
            if (attributeObj.hasOwnProperty('attr_Id')) {
                datatype = DatabaseWrappersFactory.getInstance().getDatatype(dbTyp_Id, attributeObj.attrDTyp_Id);
                if (!datatype) return dataTypeName;
            } else if (attributeObj.hasOwnProperty('lAttr_Id')) {
                datatype = DatabaseWrappersFactory.getInstance().getDatatype(dbTyp_Id, attributeObj.dTyp_Attr_Id);
                if (!datatype) return dataTypeName;
            }
        }

        dataTypeName = datatype.name;

        let precScale: string = '';
        if (datatype.enableprecision == 'y')
            precScale = attributeObj.attrPrec;
        if (datatype.enablescale == 'y')
            precScale += ',' + attributeObj.attrScale;

        if (precScale != '')
            dataTypeName += ' (' + precScale + ')';

        return dataTypeName;
    }

    getAttrDTyp_IdByName(dbTyp_Id: number, attrDTyp_Nm: string) {
        let databaseWrapper: DatabaseWrapper = DatabaseWrappersFactory.getInstance().getDatabaseWrapper(dbTyp_Id);
        if (!databaseWrapper) return null;

        for (let i = 0; i < databaseWrapper.database.datatype.length; i++) {
            let _datatype = databaseWrapper.database.datatype[i];
            if (_datatype.name != attrDTyp_Nm) continue;
            return _datatype.id;
        }

        return null;
    }

    getDatatypeByName(dbTyp_Id: number, attrDTyp_Nm: string) {

        var attrDTyp_Id = this.getAttrDTyp_IdByName(dbTyp_Id, attrDTyp_Nm);
        if (!attrDTyp_Id) return;

        return DatabaseWrappersFactory.getInstance().getDatatype(dbTyp_Id, attrDTyp_Id);
    }

    showAttrPrec(dbTyp_Id: number, attrDTyp_Id: number, attrPrec: number) {

        let datatype: Datatype = DatabaseWrappersFactory.getInstance().getDatatype(dbTyp_Id, attrDTyp_Id);

        if (!datatype) return '';
        if (datatype.enableprecision == 'n') return '';

        return attrPrec;
    }


    getMaxPrec(dbTyp_Id: number, attrDTyp_Id: number) {

        let datatype: Datatype = DatabaseWrappersFactory.getInstance().getDatatype(dbTyp_Id, attrDTyp_Id);
        if (!datatype) return 0;

        return datatype.maxprec;
    }

    showAttrScale(dbTyp_Id: number, attrDTyp_Id: number, attrScale: number) {

        let datatype: Datatype = DatabaseWrappersFactory.getInstance().getDatatype(dbTyp_Id, attrDTyp_Id);

        if (!datatype) return '';
        if (datatype.enablescale == 'n') return '';

        return attrScale;
    }
    getMaxScale(dbTyp_Id: number, attrDTyp_Id: number) {

        var datatype = DatabaseWrappersFactory.getInstance().getDatatype(dbTyp_Id, attrDTyp_Id);
        if (!datatype) return 0;

        return datatype.maxscale;
    }

    getNextCLevelValue(cLevel: number, cLevels: Array<number>): number {
        if ((cLevel == 0 || cLevel == 1) &&
            cLevel == cLevels[cLevels.length - 1]) {
            return cLevel + CommonEnums.defaults.CLEVEL;
        } else if (cLevel != 0 && cLevel != 1) {
            return cLevel + CommonEnums.defaults.CLEVEL + 1;
        }

        for (let i = 0; i < cLevels.length; i++) {
            if (cLevel == cLevels[i])
                return cLevels[i + 1];
        }

        return cLevel + CommonEnums.defaults.CLEVEL;
    }

    copy(attributesTmp: Array<Attribute>): Array<Attribute> {
        let attributes: Array<Attribute> = new Array<Attribute>();

        for (let i: number = 0; i < attributesTmp.length; i++) {
            attributes.push(Attribute.parse(attributesTmp[i]))
        }

        return attributes;
    }

    copyFromWindowAttribute(attribute) {
        let dateAndTimeAttributeTmp = new Transformation();

        dateAndTimeAttributeTmp.obj_Id = attribute.obj_Id;
        dateAndTimeAttributeTmp.objNm = attribute.objNm;
        dateAndTimeAttributeTmp.text = attribute.text;
        dateAndTimeAttributeTmp.obj_Cd = attribute.obj_Cd;
        dateAndTimeAttributeTmp.dbTyp_Id = attribute.dbTyp_Id;
        dateAndTimeAttributeTmp.nativeDbTyp_Id = attribute.nativeDbTyp_Id;
        dateAndTimeAttributeTmp.imageUrl = attribute.imageUrl;
        dateAndTimeAttributeTmp.name = attribute.name;
        dateAndTimeAttributeTmp.expanded = attribute.expanded;
        dateAndTimeAttributeTmp.items = new Array();
        dateAndTimeAttributeTmp.checked = attribute.checked;
        return dateAndTimeAttributeTmp;
    }
    copyFrom(attributes: Array<Attribute>, attributesTmp: Array<Attribute>): void {
        let attributesMap: Map<number, Attribute> = new Map<number, Attribute>();

        for (let i: number = 0; i < attributes.length; i++) {
            let attribute: Attribute = attributes[i];
            attributesMap.set(attribute.attr_Id, attribute);
        }

        attributes.splice(0, attributes.length);

        for (let i: number = 0; i < attributesTmp.length; i++) {
            let attributeTmp: Attribute = attributesTmp[i];

            let attribute: Attribute = attributesMap.get(attributeTmp.attr_Id);
            if (attribute) {
                attribute.copyFrom(attributeTmp);
            } else {
                attribute = Attribute.parse(attributeTmp);
            }

            attributes.push(attribute);
        }
    }
    getattrKeyTyp_Ids(attrKeyTyp_Id) {
        let keyTypes: Map<number, string> = new Map<number, string>()
        keyTypes.set(0, "Not a key");
        keyTypes.set(1, "Primary key");
        keyTypes.set(2, "Foreign key");
        let label = keyTypes.get(parseInt(attrKeyTyp_Id));
        if (!label) return '';
        return label;
    }
    compare(attributes: Array<Attribute>, attributesTmp: Array<Attribute>): string {
        let attributesLength = attributes.length;
        let attributesTmpLength = attributesTmp.length;

        if (attributesLength != attributesTmpLength) {
            return 'Attributes length is different.';
        }

        for (let i: number = 0; i < attributesLength; i++) {
            if (attributes[i].compare(attributesTmp[i]) != '') {
                return 'attributes [' + i + '] is not equal.'
            }
        }

        return '';
    }

    toString(attributes: Array<Attribute>): string {
        let str: string = '';

        str += 'Attributes length: ' + attributes.length + ' ';

        for (let i: number = 0; i < attributes.length; i++) {
            str += attributes[i].toString();
        }

        return str;
    }
}